import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Article from "@/pages/article/page";
import YoybuyVsKakobuy from "@/pages/yoybuy-vs-kakobuy/page";
import YoybuyVsSuperbuy from "@/pages/yoybuy-vs-superbuy/page";
import KakobuyVsSuperbuy from "@/pages/kakobuy-vs-superbuy/page";
import SuperbuyAlternative from "@/pages/superbuy-alternative/page";
import FAQ from "@/pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article",
    element: <Article />,
  },
  {
    path: "/yoybuy-vs-kakobuy",
    element: <YoybuyVsKakobuy />,
  },
  {
    path: "/yoybuy-vs-superbuy",
    element: <YoybuyVsSuperbuy />,
  },
  {
    path: "/kakobuy-vs-superbuy",
    element: <KakobuyVsSuperbuy />,
  },
  {
    path: "/superbuy-alternative",
    element: <SuperbuyAlternative />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;